import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

type GetTaskParams = {
  status: 1 | 0;
  taskId: number;
};

export const getTask = async ({ status, taskId }: GetTaskParams) => {
  const { data }: { data: JsonDataItem } = await baseQuery(`task?status=${status}&task_ID=${taskId}`);
  return data;
};
